var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M11.5 12.5781C12.0954 12.5781 12.5781 12.0954 12.5781 11.5C12.5781 10.9046 12.0954 10.4219 11.5 10.4219C10.9046 10.4219 10.4219 10.9046 10.4219 11.5C10.4219 12.0954 10.9046 12.5781 11.5 12.5781Z",
    fill: "#FF5A62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 2.15625C6.34791 2.15625 2.15625 6.34791 2.15625 11.5C2.15625 16.6521 6.34791 20.8438 11.5 20.8438C16.6521 20.8438 20.8438 16.6521 20.8438 11.5C20.8438 6.34791 16.6521 2.15625 11.5 2.15625ZM16.2199 7.24725L14.114 12.5121C13.9694 12.8737 13.7528 13.2021 13.4775 13.4775C13.2021 13.7528 12.8737 13.9694 12.5121 14.114L7.24725 16.2199C7.18194 16.2461 7.11039 16.2525 7.04148 16.2383C6.97257 16.2242 6.90932 16.1902 6.85958 16.1404C6.80984 16.0907 6.77579 16.0274 6.76165 15.9585C6.74752 15.8896 6.75392 15.8181 6.78006 15.7528L8.886 10.4879C9.0306 10.1263 9.24715 9.79788 9.52252 9.52252C9.79788 9.24715 10.1263 9.0306 10.4879 8.886L15.7528 6.78006C15.8181 6.75392 15.8896 6.74752 15.9585 6.76165C16.0274 6.77579 16.0907 6.80984 16.1404 6.85958C16.1902 6.90932 16.2242 6.97257 16.2383 7.04148C16.2525 7.11039 16.2461 7.18194 16.2199 7.24725Z",
    fill: "#FF5A62"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompass);
export default __webpack_public_path__ + "static/media/compass.683cbd57.svg";
export { ForwardRef as ReactComponent };